export default __webpack_public_path__ + "static/media/IMG_2447.d7e28f44.jpg";